"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readLocal = exports.unsetLocal = exports.setLocal = void 0;
const Record_1 = require("../../utils/Record");
const Logger_1 = require("../../Logger");
function setLocal(actorId, key, value) {
    const actor = this.getActor(actorId);
    Logger_1.EngineLogger.debug(`100|setLocal|adventureId#${this.adventure.adventureId}|actorId#${actorId}|key#${key}|value#${value}`);
    (0, Record_1.setValue)(actor.locals, key, value);
}
exports.setLocal = setLocal;
function unsetLocal(actorId, key) {
    const actor = this.getActor(actorId);
    Logger_1.EngineLogger.debug(`100|unsetLocal|adventureId#${this.adventure.adventureId}|actorId#${actorId}|key#${key}`);
    delete actor.locals[key];
}
exports.unsetLocal = unsetLocal;
function readLocal(actorId, key, defaultValue) {
    const actor = this.getActor(actorId);
    Logger_1.EngineLogger.debug(`100|readLocal|adventureId#${this.adventure.adventureId}|actorId#${actorId}|key#${key}`);
    return (0, Record_1.getValueOrDefaultTo)(actor.locals, key, defaultValue);
}
exports.readLocal = readLocal;
